import styled, {keyframes} from 'styled-components'

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`

const slideDown = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

const Style = {
	Overlay: styled.div.withConfig({
		shouldForwardProp: (prop) => prop !== 'isAnimating',
	})`
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		opacity: ${({isAnimating}) => (isAnimating ? '1' : '0')};
		animation: ${({isAnimating}) => (isAnimating ? fadeIn : fadeOut)} 0.3s
			ease-out;
		z-index: 1000;
		display: flex;
		align-items: flex-end;
	`,

	Container: styled.div.withConfig({
		shouldForwardProp: (prop) => prop !== 'isAnimating',
	})`
		background-color: ${({theme}) => theme.color.white || '#FFFFFF'};
		border-radius: 20px 20px 0px 0px;
		width: 100%;
		max-height: 80vh;
		display: flex;
		flex-direction: column;
		animation: ${({isAnimating}) => (isAnimating ? slideUp : slideDown)} 0.3s
			ease-out;
		transform: translateY(${({isAnimating}) => (isAnimating ? '0' : '100%')});
	`,

	Header: styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px;
		border-bottom: 1px solid ${({theme}) => theme.color.grey2 || '#F3F4F6'};
		min-height: 56px;
		flex-shrink: 0;
		background-color: ${({theme}) => theme.color.white || '#FFFFFF'};
		border-radius: 20px 20px 0px 0px;
		position: sticky;
		top: 0;
		z-index: 1;
	`,

	Title: styled.h2`
		${({theme}) => theme.font.medium || theme.font.large};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		margin: 0;
		font-size: 20px;
		font-weight: 400;
		line-height: 1.2;
		flex: 1;
	`,

	CloseButton: styled.button`
		background: none;
		border: none;
		padding: 4px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;
		border-radius: 50%;
		transition: background-color 0.2s ease;

		&:hover {
			background-color: ${({theme}) => theme.color.grey1 || '#EEF0F2'};
		}
	`,

	CloseIcon: styled.div`
		width: 16px;
		height: 16px;
		position: relative;

		&::before,
		&::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			width: 12px;
			height: 2px;
			background-color: ${({theme}) => theme.color.black || '#1F2024'};
			border-radius: 1px;
		}

		&::before {
			transform: translate(-50%, -50%) rotate(45deg);
		}

		&::after {
			transform: translate(-50%, -50%) rotate(-45deg);
		}
	`,

	Content: styled.div`
		padding: 16px;
		display: flex;
		flex-direction: column;
		gap: 16px;
		overflow-y: auto;
		flex: 1;
		min-height: 0;
	`,

	Footer: styled.div`
		padding: 14px;
		border-top: 1px solid ${({theme}) => theme.color.grey2 || '#F3F4F6'};
	`,
}

export default Style
